import { z } from 'zod';
export const credentialSessionRequestSchema = z.object({
    joinToken: z.string().min(40).max(128),
    pin: z.string().regex(/^\d{6}$/),
});
export const moderatorSessionRequestSchema = z.union([
    z.object({ pin: z.string().regex(/^\d{6}$/) }).strict(),
    credentialSessionRequestSchema.strict(),
]);
export const sessionContextSchema = z.discriminatedUnion('role', [
    z.object({
        role: z.literal('TEAM'),
        gameId: z.string().min(1),
        teamId: z.string().min(1),
        entryName: z.string().optional(),
        expiresAt: z.string().datetime(),
    }),
    z.object({
        role: z.literal('MODERATOR'),
        gameId: z.string().min(1),
        expiresAt: z.string().datetime(),
    }),
]);
export const teamSlotCommandSchema = z.object({
    expectedGameVersion: z.number().int().nonnegative(),
});
export const moderatorTeamRenameSchema = z.object({
    expectedTeamVersion: z.number().int().nonnegative(),
    displayName: z.string().trim().min(1).max(160),
});
export const teamCredentialIssueSchema = z.object({
    teamId: z.string().min(1),
    joinUrl: z.string().url(),
    pin: z.string().regex(/^\d{6}$/),
    expiresAt: z.string().datetime(),
});
export const teamAccessSummarySchema = z.object({
    teamId: z.string().min(1),
    displayName: z.string().min(1),
    version: z.number().int().nonnegative(),
    active: z.boolean(),
    expiresAt: z.string().datetime(),
    joinUrl: z.string().url().optional(),
    pin: z
        .string()
        .regex(/^\d{6}$/)
        .optional(),
});
export const teamAccessListSchema = z.array(teamAccessSummarySchema);
export const publicTeamChoiceSchema = z.object({
    teamId: z.string().min(1),
    displayName: z.string().min(1),
    joinUrl: z.string().url(),
});
export const publicTeamChoiceListSchema = z.array(publicTeamChoiceSchema);
export const publicGameStatusSchema = z.object({
    gameId: z.string().min(1),
    phase: z.string(),
    activeRoundNo: z.number().int().positive().nullable(),
});
//# sourceMappingURL=access.js.map